<template>
<v-form @submit.prevent="submit()">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex md8 xs12>
                <div class="d-flex">
                    <v-text-field label="Origin" placeholder="Anywhere" autocomplete="off" v-validate="{origin_address: [hidden_city_origin_address]}" v-model="form.citySearch.origin_address" :error-messages="errors.collect('city_origin_address')" id="city_origin_address_truck" data-vv-name="city_origin_address" data-vv-as="Origin Address">
                    </v-text-field>
                    <input :type="'hidden'" v-model="hidden_city_origin_address" ref="hidden_city_origin_address" data-vv-name="hidden_city_origin_address" />
                                                                    </div>
            </v-flex>
            <v-flex md4 xs12>
                <div class="d-flex">
                    <v-combobox v-model="form.citySearch.origin_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.city_origin_radius'}" id="city_origin_radius" data-vv-name="city_origin_radius" data-vv-as="Radius" placeholder="Radius" :error-messages="errors.collect('city_origin_radius')" @keyup="onOriginRadiusChange"></v-combobox>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex md8 xs12>
                <div class="d-flex">
                    <v-text-field :class="form.citySearch.destination_cities.length ? 'white-placeholder': ''" placeholder="Anywhere" label="Destination" autocomplete="off" v-model="form.citySearch.dest_address" :error-messages="errors.collect('city_dest_address')" v-validate="{city_dest_address:true,dest_address_mismatch:[form.citySearch.origin_lat,form.citySearch.origin_lng, form.citySearch.dest_lat,form.citySearch.dest_lng]}" id="city_dest_address_truck" data-vv-name="city_dest_address" data-vv-as="Destination Address">
                    </v-text-field>
                    <input :type="'hidden'" v-model="hidden_city_dest_address" ref="hidden_city_dest_address" data-vv-name="hidden_city_dest_address" />
                </div>
                <div v-if="form.citySearch.destination_cities.length" :class="!errors.collect('city_dest_address').length ? 'customChip' : ''">
                    <v-chip @input="cityDestChipChange(index)" close v-for="(item, index) in form.citySearch.destination_cities" v-bind:key="index">
                        {{item.dest_city !== '' ? item.dest_city + ',&nbsp;' + item.state_code : item.state_name}}
                    </v-chip>
                </div>
            </v-flex>
            <v-flex md4 xs12>
                <div class="d-flex">
                    <v-combobox v-model="form.citySearch.dest_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.city_dest_radius'}" id="city_dest_radius" data-vv-name="city_dest_radius" data-vv-as="Radius" placeholder="Radius" :error-messages="errors.collect('city_dest_radius')" @keyup="onDestRadiusChange"></v-combobox>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg4 md4 xs12>
                <v-menu ref="picker_available_date" lazy :close-on-content-click="false" v-model="form.citySearch.picker_available_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.citySearch.available_date">
                    <v-text-field class="custom-picker-text" id="available_date" v-validate="'required'" data-vv-name="available_date" data-vv-as="Available Date" :error-messages="errors.collect('available_date')" slot="activator" label="Available Date *" :value="displayDate(form.citySearch.available_date)" prepend-icon="event" readonly></v-text-field>
                    <v-date-picker :min="minDate" v-model="form.citySearch.available_date" no-title scrollable @input="changePickerDate('available'); $refs.picker_available_date.save(form.citySearch.available_date)">
                    </v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex lg4 md4 xs12>
                <div class="d-flex">
                    <v-autocomplete class="auotchoice" :items="equipment_types" v-validate="{required:'form.equipment_types'}" :error-messages="errors.collect('equipment_types')" data-vv-name="equipment_types" data-vv-rules="equipment_types" v-model="equipment_type_id_list" required data-vv-as="Equipment Types" item-text="name" item-value="code" label="Equipment Types *" multiple v-on:change="onEquipmentChange"></v-autocomplete>
                </div>
            </v-flex>
            <v-flex lg4 md4 xs12>
                <div class="d-flex">
                    <v-select class="custom_dropdown" :items="truck_size_arr" :error-messages="errors.collect('load_size')" data-vv-name="load_size" v-model="form.citySearch.load_size" required data-vv-as="Load Size" item-text="name" item-value="id" label="Load Size">
                    </v-select>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <div class="form-btn text-xs-right">
        <v-btn type="submit" color="green white--text">
            <v-icon>search</v-icon> Find Trucks
        </v-btn>
    </div>
</v-form>
</template>
<script>
const ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
import services from "../../../services/HttpService";
import {
    Validator
} from 'vee-validate';
import moment from 'moment';
import config from "../../../config";
import utils from "../../../util";
Validator.extend('origin_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

Validator.extend('dest_address_mismatch', {
    getMessage: field => config.validationMsgForOriginDestNotSame,
    validate: function (value, [origin_lat, origin_lng, destination]) {
        if (Object.keys(destination).length) {
            if (origin_lat != '' && origin_lng != '' && origin_lat == destination.lat && origin_lng == destination.lng) {
                return false;
            }
        }
        return true;
    }
});

export default {
    props:[
        "dashboard_equipment_type_id_list",
        "dashboard_equipment_types"
    ],
    $_veeValidate: {
        validator: "new"
    },
    created() {
        const self = this;
        self.utils = utils;    
    },
    watch:{
        'dashboard_equipment_types': function (val, oldVal){
            const self = this;
            self.equipment_types = JSON.parse(JSON.stringify(self.dashboard_equipment_types));
        },
        'dashboard_equipment_type_id_list': function (val, oldVal){
            const self = this;
            self.equipment_type_id_list = JSON.parse(JSON.stringify(self.dashboard_equipment_type_id_list));
        }
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
    },
    data: () => ({
        auto: "true",
        form: {
            citySearch: {
                origin_address: '',
                origin_city: '',
                origin_lat: '',
                origin_lng: '',
                destination_cities: [],
                dest_address: '',
                dest_city: '',
                dest_lat: '',
                dest_lng: '',
                dest_radius: 50,
                selected_dest: {},
                equipment_type_id: '',
                origin_radius: 50,
                available_date: new Date().toISOString().substr(0, 10),
                picker_available_date: '',
                load_size: '',
            }
        },
        equipment_type_id_list: [],
        equipment_types: [],
        hidden_city_origin_address: '',
        hidden_city_dest_address: '',
        truck_size_arr: [{
            name: 'ANY',
            id: ''
        }, {
            name: 'LTL',
            id: 'LTL'
        }, {
            name: 'FULL',
            id: 'FULL'
        }],

    }),
    mounted() {
        const self = this;
        setTimeout(function() {
            if(document.getElementById('city_origin_address_truck')){
                document.getElementById('city_origin_address_truck').setAttribute('autocomplete', 'disabled');
            }
            if(document.getElementById('city_dest_address_truck')){
                document.getElementById('city_dest_address_truck').setAttribute('autocomplete', 'disabled');
            }
        }, 1000);
        self.$validator.localize("en", self.dictionary);
        self.initGoogleAutocomplete();
        
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        displayDate(selectedDate,type){
            if(this.form.citySearch.available_date && this.form.citySearch.available_date.length > 0){
                return moment(selectedDate).format(config.displayDateFormat);
            }
            return '';
        },
        submit() {
            const self = this;
            self.$validator.validateAll()
                .then(isValid => {
                    if (isValid) {
                        const params = this._formatSearchForm();
                        self.$router.push({
                            name: "SearchTrucks",
                            params: {
                                queryString: params,
                                originalData: self.form.citySearch
                            }
                        });
                    }
                });
        },
        initGoogleAutocomplete() {
            this.bindAutocompleteEv('origin', 'city');
            this.bindAutocompleteEv('dest', 'city');
        },
        bindAutocompleteEv(placeType, tabType) {
            const self = this,
                options = {};
            let acInstance = self[placeType + '_autocomplete'];
            acInstance = new google.maps.places.Autocomplete(
                document.getElementById(tabType + '_' + placeType + '_address_truck'),
                options
            );
            acInstance.setComponentRestrictions({
                'country': ['CAN', 'US']
            });
            acInstance.addListener('place_changed', function () {
                let place = acInstance.getPlace();
                if (place.address_components !== undefined) {
                    let returnData = {};
                    for (let i = 0; i < place.address_components.length; i++) {
                        let addressType = place.address_components[i].types[0];
                        if (addressType == 'administrative_area_level_1') {
                            let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                            returnData[addressType] = val;
                            returnData['origin_map_state_code'] = place.address_components[i]['short_name'];
                            returnData['state_name'] = place.address_components[i]['long_name'];
                        } else if (ADDRESS_COMPONENTS[addressType]) {
                            let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                            returnData[addressType] = val;
                        }
                    }
                    const searchField = self.form[tabType + 'Search'],
                        lat = place.geometry.location.lat(),
                        lng = place.geometry.location.lng(),
                        city = returnData.locality;
                    if (tabType === 'city' && placeType === 'dest') {
                        self.form.citySearch.selected_dest = {
                            lat,
                            lng
                        };
                        self.$validator.validateAll('city_dest_address');
                        self.addPlaceToDestinations(tabType, {
                            lat,
                            lng,
                            'dest_city': city ? city : '',
                            'state_code':returnData.origin_map_state_code ? returnData.origin_map_state_code : '',
                            'state_name': returnData.state_name ? returnData.state_name : ''
                        });
                    } else {
                        searchField[placeType + '_address'] = place.formatted_address;
                        searchField[placeType + '_city'] = city;
                        searchField[placeType + '_state'] = returnData.administrative_area_level_1;
                        self['hidden_' + tabType + '_' + placeType + '_address'] = place.formatted_address;
                        searchField[placeType + '_lat'] = lat;
                        searchField[placeType + '_lng'] = lng;
                        if (tabType == 'map') {
                            self.origin_map_state_code = returnData.origin_map_state_code;
                            self.mapChangesOrigin();
                            self.mapChangesOriginBoth();
                        }
                    }
                } else {
                    self['hidden_' + tabType + '_' + placeType + '_address'] = '';
                }
            });
        },
        addPlaceToDestinations(tabType, location) {
            const citySearch = this.form.citySearch;
            if (this._checkIfDestExists(location)) {
                if(location.dest_city != '' || location.state_code != '' || location.state_name != ''){
                    location.lat = location.lat.toString();
                    location.lng = location.lng.toString();
                    citySearch.destination_cities.push(location);
                }
            }
            citySearch.dest_address = '';
            citySearch.dest_city = '';
            citySearch.dest_lat = '';
            citySearch.dest_lng = '';
        },
        _checkIfDestExists(location) {
            const destinations = this.form.citySearch.destination_cities;
            let isValid = true;
            for (var i = 0; i < destinations.length; i++) {
                if (destinations[i].lat == location.lat && destinations[i].lng == location.lng) {
                    isValid = false;
                    break;
                }
            }
            return isValid;
        },
        cityDestChipChange(i) {
            this.form.citySearch.destination_cities.splice(i, 1);
        },
        _formatSearchForm() {
            const _dt = Object.assign({}, this.form.citySearch),
                _tmpDt = Object.assign({}, this.form.citySearch);
            const discardFields = {
                'origin_lat': true,
                'origin_lng': true,
                'origin_city': true,
                'origin_address': true,
                'origin_state': true,
                'dest_address': true,
                'picker_delivery_date': true,
                'selected_dest': true
            };
            if(this.form.citySearch.origin_radius === config.ANYStr || !this.form.citySearch.origin_radius){
                discardFields.origin_radius = true;
            }
            if(this.form.citySearch.dest_radius === config.ANYStr || !this.form.citySearch.dest_radius){
                discardFields.dest_radius = true;
            }
            let strParams = '';
            for (var key in _dt) {
                if (_dt.hasOwnProperty(key)) {
                    if (discardFields[key] || (_dt[key] === false)) {
                        delete _dt[key];
                    } else {
                        if (key == 'destination_cities' && !_dt[key].length) {
                            continue;
                        }
                        if(key == 'equipment_type_id'){
                            if(this.equipment_type_id_list[0].code != config.ANYStr && this.equipment_type_id_list[0] != config.ANYStr){
                                _dt[key] = this.equipment_type_id_list.join(',');
                                this.form.citySearch.equipment_type_id = this.equipment_type_id_list.join(',');
                            }
                            else {
                                delete _dt[key];
                                this.form.citySearch.equipment_type_id = config.ANYStr;
                                continue;
                            }
                        }
                        const val = typeof _dt[key] === 'object' ? JSON.stringify(_dt[key]) : _dt[key];
                        strParams = !strParams ? key + '=' + val : strParams + '&' + key + '=' + val;
                    }
                }
            }
            if (_tmpDt.origin_lat && _tmpDt.origin_lng) {
                const orgCity = JSON.stringify([{
                    'lat': _tmpDt.origin_lat.toString(),
                    'lng': _tmpDt.origin_lng.toString(),
                    'origin_city': _tmpDt.origin_city ? _tmpDt.origin_city : ''
                }]);
                strParams = !strParams ? 'origin_city=' + orgCity : strParams + '&origin_city=' + orgCity;
            }
            return strParams;
        },
        changePickerDate(type) {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById(type + '_date').dispatchEvent(evt);
            }, 10)
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        },
        onEquipmentChange(data) {
            const self = this;
            if(data != ''){
                let selectedEquipmentCode = data.toString().split(',');
                self.equipment_type_id_list = [];
                if(selectedEquipmentCode[(selectedEquipmentCode.length -1)]==config.ANYStr){
                    self.equipment_type_id_list.push(config.ANYStr);
                }else{
                    selectedEquipmentCode.map(async function (equipmentCode) {
                        if(equipmentCode != config.ANYStr){
                            await self.equipment_type_id_list.push(equipmentCode);
                        }        
                    });
                }
            }
        },
        onOriginRadiusChange(data) {
            this.form.citySearch.origin_radius = data.target.value;                                                         
        },
        onDestRadiusChange(data) {
            this.form.citySearch.dest_radius = data.target.value;
        },
        onMapRadiusChange(data){
            this.form.mapSearch.radius = data.target.value;
        }
    }
};
</script>

<style lang="stylus" scoped>
.payment-method {
    border: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/form/TruckSearchFormDb.vue